import { useMemo } from 'react'
import { TableContextValue } from './useTableContext'

const useTableContextValue = ({
  actionButton,
  actionColumns,
  actionColumnsPosition,
  allColumns,
  allowCollapsibleNavigationCardCustomColors,
  allowHighlightSelectedRow,
  amountOfActionColumns,
  amountOfFixedColumns,
  changedFieldValues,
  columnsLayouts,
  columnsNames,
  concatFields,
  currentColumnIndex,
  customActionButtons,
  disableLinkButton,
  displayLayoutSelection,
  embedded,
  extraColumns,
  extraSelectionActions,
  fields,
  hideEditAction,
  hideInsertAction,
  hideDocumentUploadAction,
  hideMainCollapsibleContainer,
  hideRowActionButtons,
  hideSelectAndLinkAction,
  hideSortButtons,
  hierarchyLevel,
  idObjectClass,
  informational,
  insertOnly,
  isShowPDFReports,
  isShowXLSReport,
  layoutClassificationUuid,
  mapColumnToAction,
  mode,
  navigationSliderBackgroundColor,
  navigationSliderColor,
  objectclass,
  objectclassQueryString,
  objects,
  onChangeColumnsPage,
  onSort,
  pagination,
  primarySelectionAction,
  readOnlyColumns,
  refetchObjects,
  relationColumnName,
  relationCounterpartField,
  selectAndLinkOptions,
  selectedRows,
  setChangedFieldValues,
  setMode,
  setSelectedRows,
  sortOptions,
  totalColumns,
  totalObjects,
  highlightedRows,
  selectAndLinkTargetPath,
  textFading,
  uploadAcceptedFileTypes,
  extendMobileAreaLine,
  objectClassTitle,
  onBeforeViewObject
}: TableContextValue): TableContextValue => {
  return useMemo(
    () => ({
      actionButton,
      actionColumns,
      actionColumnsPosition,
      allColumns,
      allowCollapsibleNavigationCardCustomColors,
      allowHighlightSelectedRow,
      amountOfActionColumns,
      amountOfFixedColumns,
      changedFieldValues,
      columnsLayouts,
      columnsNames,
      concatFields,
      currentColumnIndex,
      customActionButtons,
      disableLinkButton,
      displayLayoutSelection,
      embedded,
      extraColumns,
      extraSelectionActions,
      fields,
      hideEditAction,
      hideInsertAction,
      hideMainCollapsibleContainer,
      hideRowActionButtons,
      hideSelectAndLinkAction,
      hideDocumentUploadAction,
      hideSortButtons,
      hierarchyLevel,
      idObjectClass,
      informational,
      insertOnly,
      isShowPDFReports,
      isShowXLSReport,
      layoutClassificationUuid,
      mapColumnToAction,
      mode,
      navigationSliderBackgroundColor,
      navigationSliderColor,
      objectclass,
      objectclassQueryString,
      objects,
      onChangeColumnsPage,
      onSort,
      pagination,
      primarySelectionAction,
      readOnlyColumns,
      refetchObjects,
      relationColumnName,
      relationCounterpartField,
      selectAndLinkOptions,
      selectedRows,
      setChangedFieldValues,
      setMode,
      setSelectedRows,
      sortOptions,
      totalColumns,
      totalObjects,
      highlightedRows,
      selectAndLinkTargetPath,
      textFading,
      uploadAcceptedFileTypes,
      extendMobileAreaLine,
      objectClassTitle,
      onBeforeViewObject
    }),
    [
      actionButton,
      actionColumns,
      actionColumnsPosition,
      allColumns,
      allowCollapsibleNavigationCardCustomColors,
      allowHighlightSelectedRow,
      amountOfActionColumns,
      amountOfFixedColumns,
      changedFieldValues,
      columnsLayouts,
      columnsNames,
      concatFields,
      currentColumnIndex,
      customActionButtons,
      disableLinkButton,
      displayLayoutSelection,
      embedded,
      extraColumns,
      extraSelectionActions,
      fields,
      hideEditAction,
      hideInsertAction,
      hideMainCollapsibleContainer,
      hideRowActionButtons,
      hideSelectAndLinkAction,
      hideDocumentUploadAction,
      hideSortButtons,
      hierarchyLevel,
      idObjectClass,
      informational,
      insertOnly,
      isShowPDFReports,
      isShowXLSReport,
      layoutClassificationUuid,
      mapColumnToAction,
      mode,
      navigationSliderBackgroundColor,
      navigationSliderColor,
      objectclass,
      objectclassQueryString,
      objects,
      onChangeColumnsPage,
      onSort,
      pagination,
      primarySelectionAction,
      readOnlyColumns,
      refetchObjects,
      relationColumnName,
      relationCounterpartField,
      selectAndLinkOptions,
      selectedRows,
      setChangedFieldValues,
      setMode,
      setSelectedRows,
      sortOptions,
      totalColumns,
      totalObjects,
      highlightedRows,
      selectAndLinkTargetPath,
      textFading,
      uploadAcceptedFileTypes,
      extendMobileAreaLine,
      objectClassTitle,
      onBeforeViewObject
    ]
  )
}

export default useTableContextValue
